import styled from '@emotion/styled';
import { ModalStyled } from '@nike/nike-design-system-components';
import { desktopOnly, focusRingStyle } from '../../utils/sharedStyles';
import { iconPrimaryHover } from '../../utils/inconsistentVars';

const arabicLanguage = 'Neue Frutiger Arabic';
export const countryLink = 'country-link';
export const accordionPanelWrapper = 'accordion-panel-wrapper';
export const isHidden = 'is-hidden';
export const closeButton = 'close-button';
export const languageModalRoot = 'language-modal-root';
export const hiddenFocusableAccessibilityButton = 'hidden-focusable-accessibility-button';

export const StyledLanguageModal = styled(ModalStyled)`
  color: var(--podium-cds-color-text-primary);
  text-align: center;
  .close-btn-container button:nth-of-type(1) {
    background: var(--podium-cds-button-color-bg-primary);
  }
  .close-btn-container svg path {
    color: var(--podium-cds-color-text-primary-inverse);
  }
  .modal-header-container h1 {
    font: var(--podium-cds-typography-320-to-1919-title2);
  }
  section {
    div:nth-of-type(2) {
      overflow: visible;
    }
  }
  .${closeButton} {
    ${focusRingStyle}
  }
  // ncss 4.2 compatibility
  .close-btn-container > button.${closeButton} {
    &:before {
      border: none;
    }
    color: var(--podium-cds-color-text-primary-inverse);
    ${focusRingStyle}
    &:hover:not(:disabled),
    &:active {
      background-color: ${iconPrimaryHover};
    }
  }
  .${languageModalRoot} {
    max-height: 100vh;
    height: 100%;
    padding: 40px var(--podium-cds-size-spacing-l) var(--podium-cds-size-spacing-l)
      var(--podium-cds-size-spacing-l);
    overflow: auto;
    scrollbar-width: none;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    .${hiddenFocusableAccessibilityButton} {
      position: absolute;
    }
  }
`;

export const StyledLocationPin = styled.svg`
  width: 24px;
  float: left;
  padding-right: 4px;
  height: 30px;
  color: var(--podium-cds-color-grey-300);
`;

export const StyledGeo = styled.h2`
  color: var(--podium-cds-color-text-primary);
  text-align: left;
  font: var(--podium-cds-typography-320-to-1919-title2);
  width: 214px;
  padding-top: 36px;
  list-style-type: none;
  line-height: 120%;
  padding-bottom: 36px;
`;

export const StyledWrapper = styled.div`
  width: 100%;
  &.${isHidden} {
    display: none;
  }
  @media (${desktopOnly}) {
    padding: 0px 30px 80px 30px;
    width: 100%;
    max-width: 980px;
    margin: 0 auto;
  }
`;
export const localeLabelContainer = 'locale-label-container';
export const StyledList = styled.ul`
  display: grid;
  grid-template-rows: repeat(n, minmax(auto, 1fr));
  gap: var(--podium-cds-size-spacing-grid-gutter-l);
  .${countryLink} {
    color: var(--podium-cds-color-text-primary);
    display: block;
    text-align: left;
    padding: 12px 12px 12px 8px;
    border-radius: 18px;
    border: 1px solid var(--podium-cds-color-border-disabled);
    &:hover {
      background: var(--podium-cds-color-border-disabled);
      svg {
        color: var(--podium-cds-color-border-primary);
      }
    }
    background: var(--podium-cds-color-bg-primary);
  }
  @media (${desktopOnly}) {
    grid-template-columns: repeat(auto-fit, 215px);
    .${countryLink} {
      width: 216px;
    }
  }
  .${localeLabelContainer} {
    margin-left: 28px;
  }
  p,
  h4 {
    display: flex;
    &.arabic {
      font-family: ${arabicLanguage};
      text-align: right;
      justify-content: end;
    }
  }
`;

export const StyledAccordionHeader = styled.div`
  font: var(--podium-cds-typography-320-to-1919-title3);
  .${accordionPanelWrapper} {
    width: 100%;
  }
`;
